
import $ from "jquery";
import filters from "@/filters";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { constants } from "crypto";

@Component({
  filters,
})
export default class UploadedFile extends Vue {
  // PROP

  @Prop({ default: "uploadProgress" }) private id: string;
  @Prop({ default: "Document.xls" }) private filename: string;
  @Prop({ default: 0 }) private totalCandidate: number;
  @Prop({ default: 0 }) private totalSuccessCandidate: number;
  @Prop({ default: false }) private successStatus: boolean;
  @Prop({
    default: () => {
      //
    },
  })
  private cancel: () => void;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* METHOD */
  private isUploadSuccess() {
    return (
      this.successStatus === true &&
      this.totalCandidate === this.totalSuccessCandidate
    );
  }
  private isUploadPartial() {
    return (
      this.totalCandidate > this.totalSuccessCandidate &&
      this.successStatus === true
    );
  }
  private isUploadFailed() {
    return this.successStatus === false;
  }
  private sectionStyling() {
    if (this.isUploadSuccess()) {
      return "UploadSuccess";
    }
    if (this.isUploadFailed()) {
      return "UploadFailed";
    }
    if (this.isUploadPartial()) {
      return "UploadPartial";
    }
  }
}
